import { StyleSheet } from 'react-native';
import { WARMUP_COLORS } from '../../../src/quiz/constants/warmup.constants';

export const wordleResultOverlayStyles = StyleSheet.create({
  backdrop: {
    ...StyleSheet.absoluteFillObject,
    backgroundColor: 'rgba(0,0,0,0.78)',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 24,
  },
  card: {
    width: '100%',
    maxWidth: 420,
    backgroundColor: WARMUP_COLORS.surface,
    borderRadius: 20,
    borderWidth: 1,
    borderColor: WARMUP_COLORS.border,
    padding: 24,
    alignItems: 'center',
    gap: 6,
  },
  emoji: {
    fontSize: 40,
    lineHeight: 44,
  },
  title: {
    fontSize: 22,
    fontWeight: '800',
    color: WARMUP_COLORS.text,
    textAlign: 'center',
  },
  coinChip: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 7,
    backgroundColor: WARMUP_COLORS.amber,
    borderRadius: 9999,
    paddingVertical: 7,
    paddingHorizontal: 16,
    marginTop: 8,
  },
  coinChipText: {
    fontSize: 16,
    fontWeight: '800',
    color: WARMUP_COLORS.textOnBright,
  },
  revealCard: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 10,
    marginTop: 10,
    backgroundColor: WARMUP_COLORS.cardRaised,
    borderWidth: 1,
    borderColor: WARMUP_COLORS.borderPurpleStrong,
    borderRadius: 12,
    paddingVertical: 11,
    paddingHorizontal: 16,
  },
  revealFlag: {
    fontSize: 24,
  },
  revealName: {
    fontSize: 16,
    fontWeight: '800',
    color: WARMUP_COLORS.text,
  },
  revealClub: {
    fontSize: 12,
    fontWeight: '500',
    color: WARMUP_COLORS.textDim,
  },
  sub: {
    fontSize: 13,
    color: WARMUP_COLORS.textDim,
    textAlign: 'center',
    marginTop: 6,
    fontWeight: '500',
  },
  grid: {
    fontSize: 18,
    letterSpacing: 3,
    lineHeight: 26,
    textAlign: 'center',
    marginVertical: 10,
  },
  shareButton: {
    width: '100%',
    backgroundColor: WARMUP_COLORS.amber,
    borderRadius: 10,
    paddingVertical: 14,
    minHeight: 50,
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: 6,
  },
  shareButtonText: {
    fontSize: 16,
    fontWeight: '700',
    color: WARMUP_COLORS.textOnBright,
  },
  closeButton: {
    width: '100%',
    borderRadius: 10,
    borderWidth: 1,
    borderColor: WARMUP_COLORS.absent,
    paddingVertical: 13,
    minHeight: 48,
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: 8,
  },
  closeButtonText: {
    fontSize: 15,
    fontWeight: '600',
    color: WARMUP_COLORS.text,
  },
  pressed: {
    opacity: 0.85,
  },
});
